// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__23Nw5","col":"styles_col__2WjPv","fulfillmentStatus":"styles_fulfillmentStatus__2KGH4","emailCol":"styles_emailCol__2M0JK"};